import Vue from 'vue'
import Router from 'vue-router'
import store from "../store/index.js"

// 一级路由
import NavBar from '@/components/navBar'

//二级路由
import Home from '@/components/home/home.vue' //首页
import Echarts from '@/components/home/echarts.vue' //首页
import LookShop from '@/components/shop/lookShop.vue' //查看商铺
import Mine from '@/components/mine/mine.vue' //我的
import Publish from '@/components/publish/publish.vue' //发布
import Message from '@/components/mine/message.vue' //我的

import Qiuzu from '@/components/publish/qiuzu.vue' //发布
import Gather from '@/components/publish/gather.vue' //发布
// 商品详情
import ShopDetail from '@/components/shop/shopDetail.vue'
import ShopMore from '@/components/shop/shopMore.vue'
import ShopMap from '@/components/shop/shopMap.vue'

//合作品牌、大咖推荐
import Cooperation from '@/components/brand/cooperation.vue'
import Recommend from '@/components/brand/recommend.vue'

// 登陆页
import Login from '@/components/login/login.vue'
// 搜索页
import Search from '@/components/search/search.vue'
// 会员部分
import Buymember from '@/components/mine/buymember.vue'
import BuymemberH5 from '@/components/mine/buymemberH5.vue'
// 已注册会员
import Goodmember from '@/components/mine/goodmember.vue'
// 我的订单
import Order from '@/components/mine/order.vue'
// 选择支付方式
import Payment from '@/components/mine/payment.vue'
// 我的收藏
import Collect from '@/components/mine/collect.vue'
// 我的消息
// import Message from '@/components/mine/message.vue'
// 关于优铺
import AboutUP from '@/components/mine/aboutUP.vue'
// 资讯详情
import Consult from '@/components/home/consult.vue'
// 委托找铺
import SeekShop from '@/components/home/seekShop.vue'
// 委托转铺
import TurnShop from '@/components/home/turnShop.vue'
// 选择城市
import CitySelection from '@/components/home/citySelection.vue'
// 选择城市
import CitySelection1 from '@/components/home/citySelection1.vue'
//求组列表
import Wanted from '@/components/home/wanted.vue'
import WantedDetail from '@/components/home/wantedDetail.vue'
// 邀请好友
import InviteFriends from '@/components/mine/inviteFriends.vue'
// 我的邀请
import MyInvite from '@/components/mine/myInvite.vue'
// 邀请注册
import InviteRegister from '@/components/mine/inviteRegister.vue'
// 我要纠错
import ErrorCorrection from '@/components/shop/errorCorrection.vue'
// 我的发布
import MyPublish from '@/components/mine/myPublish.vue'
// 转铺会员
import TurnShopMember from '@/components/mine/turnShopMember.vue'
// 查看次数
import LookCount from '@/components/mine/lookCount.vue'
// 看铺次数明细
import LookCountDetails from '@/components/mine/lookCountDetails.vue'

// 拍店
// 拍店赚钱
import MakeMoney from '@/components/shootShop/makeMoney.vue'
// 拍店示例
import Sample from '@/components/shootShop/sample.vue'
// 奖励规则及攻略
import Rule from '@/components/shootShop/rule.vue'
// 拍店记录
import Record from '@/components/shootShop/record.vue'
// 成交案例
import Volume from '@/components/home/volume.vue'
// 设置
import SetPage from '@/components/mine/set.vue'
//加盟租铺宝
import aboutJoin from '@/components/mine/aboutJoin.vue'
//用户注册协议
import registerAgree from '@/components/login/userAgreement.vue'
//隐私协议
import privacyAgree from '@/components/login/agreement.vue'

// 找铺详情
import ZhaopuDetail from '@/components/home/zhaopudetail.vue'
// 转铺详情
import ZhuanpuDetail from '@/components/home/zhuanpudetail.vue'
// 转铺报告
import ShopReport from '@/components/home/shopreport.vue'
// 访客列表
import FkList from '@/components/home/fklist.vue'
// 资讯列表
import News from '@/components/home/news.vue'

// 极速找铺
import Zhaopuserve from '@/components/home/zhaopuserve.vue'
// 极速转铺
import Zhuanpuserve from '@/components/home/zhuanpuserve.vue'


// 即使通讯
import Messageuser from '@/components/mine/messageuser.vue' //用户1
// import Message1 from '@/components/mine/messageuser1.vue' //用户1
// import Message2 from '@/components/mine/messageuser2.vue' //用户2

//发布商铺
import publishop from '@/components/publish/publishop.vue'
import map from '@/components/publish/map.vue'
import publishneed from '@/components/publish/publishneed.vue'
import editshop from '@/components/publish/editshop.vue'
import editneed from '@/components/publish/editneed.vue'
Vue.use(Router)

const router = new Router({
    mode: "history",
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '*', name: 'navBar', redirect: "/home", component: NavBar,
            children: [
                { path: '/home', component: Home },
                {
                    path: '/lookShop',
                    component: LookShop,
                    name: "lookShop",
                    meta: { keepAlive: true }
                },
                { path: '/mine', component: Mine },
                { path: '/publish', component: Publish },
                { path: '/message', component: Message },
                // {path: '/lookShop',component: LookShop},
            ]
        },

        {
            path: '/qiuzu',
            component: Qiuzu
        },
        {
            path: '/gather',
            component: Gather
        },
        /*echarts*/
        {
            path: '/echarts',
            component: Echarts
        },
        /*商铺筛选更多*/
        {
            path: '/shopMore',
            component: ShopMore
        },
        /*合作品牌*/
        {
            path: '/cooperation',
            component: Cooperation
        },
        /*大咖推荐*/
        {
            path: '/recommend',
            component: Recommend
        },
        /*求租列表*/
        {
            path: '/wanted',
            component: Wanted
        },
        /*求租列表*/
        {
            path: '/wantedDetail',
            component: WantedDetail
        },
        /*商铺地图*/
        {
            path: '/shopMap',
            component: ShopMap
        },
        {
            path: '/shopDetail',
            component: ShopDetail
        },
        {
            path: '/buymember',
            name: 'buymember',
            component: Buymember
        },
        {
            path: '/buymemberH5',
            component: BuymemberH5
        },
        {
            path: '/goodmember',
            component: Goodmember
        },
        // 我的订单
        {
            path: '/order',
            component: Order
        },
        //  选择支付方式
        {
            path: '/payment',
            component: Payment
        },
        // 我的收藏
        {
            path: '/collect',
            component: Collect
        },
        // 我的消息
        // {
        //   path: '/message',
        //   component: Message
        // },
        // 关于优铺
        {
            path: '/aboutUP',
            component: AboutUP
        },
        // 搜索页
        {
            path: '/search',
            component: Search
        },
        // 登录页
        {
            path: '/login',
            component: Login
        },
        // 资讯详情
        {
            path: '/consult',
            component: Consult
        },
        // 委托找铺
        {
            path: '/seekShop',
            component: SeekShop
        },
        // 委托转铺
        {
            path: '/turnShop',
            component: TurnShop
        },
        // 选择城市
        {
            path: '/citySelection',
            component: CitySelection
        },
        // 邀请好友
        {
            path: '/inviteFriends',
            component: InviteFriends
        },
        // 我的邀请
        {
            path: '/myInvite',
            component: MyInvite
        },
        // 邀请注册
        {
            path: '/inviteRegister',
            component: InviteRegister
        },
        // 我要纠错
        {
            path: '/errorCorrection',
            component: ErrorCorrection
        },
        // 我的发布
        {
            path: '/myPublish',
            component: MyPublish
        },
        // 转铺会员
        {
            path: '/turnShopMember',
            component: TurnShopMember
        },
        // 拍店赚钱
        {
            path: '/makeMoney',
            component: MakeMoney
        },
        // 拍店示例
        {
            path: '/sample',
            component: Sample
        },
        // 奖励规则及攻略
        {
            path: '/rule',
            component: Rule
        },
        // 拍店记录
        {
            path: '/record',
            component: Record
        },
        // 成交案例
        {
            path: '/volume',
            component: Volume
        },
        // 设置
        {
            path: '/set',
            component: SetPage
        },
        // 查看次数
        {
            path: '/lookCount',
            component: LookCount
        },
        // 看铺次数明细
        {
            path: '/lookCountDetails',
            component: LookCountDetails
        },
        //加盟租铺宝
        {
            path: '/aboutJoin',
            component: aboutJoin
        },
        //注册协议
        {
            path: "/registerAgree",
            component: registerAgree
        },
        //隐私协议
        {
            path: '/privacyAgree',
            component: privacyAgree
        },

        // 找铺详情
        {
            path: '/zhaopudetail',
            component: ZhaopuDetail
        },
        // 转铺详情
        {
            path: '/zhuanpudetail',
            component: ZhuanpuDetail
        },

        // 即时通讯
        {
            path: '/messageuser',
            component: Messageuser
        },
        // {
        //     path: '/messageuser1',
        //     component: Message1
        // },
        // {
        //     path: '/messageuser2',
        //     component: Message2
        // },
        {
            path: '/qiuzu',
            component: Qiuzu
        },
        {
            path: '/gather',
            component: Gather
        },
        /*echarts*/
        {
            path: '/echarts',
            component: Echarts
        },
        /*商铺筛选更多*/
        {
            path: '/shopMore',
            component: ShopMore
        },
        /*合作品牌*/
        {
            path: '/cooperation',
            component: Cooperation
        },
        /*大咖推荐*/
        {
            path: '/recommend',
            component: Recommend
        },
        /*求租列表*/
        {
            path: '/wanted',
            component: Wanted
        },
        /*求租列表*/
        {
            path: '/wantedDetail',
            component: WantedDetail
        },
        /*商铺地图*/
        {
            path: '/shopMap',
            component: ShopMap
        },
        {
            path: '/shopDetail',
            component: ShopDetail
        },
        {
            path: '/buymember',
            name: 'buymember',
            component: Buymember
        },
        {
            path: '/buymemberH5',
            component: BuymemberH5
        },
        {
            path: '/goodmember',
            component: Goodmember
        },
        // 我的订单
        {
            path: '/order',
            component: Order
        },
        //  选择支付方式
        {
            path: '/payment',
            component: Payment
        },
        // 我的收藏
        {
            path: '/collect',
            component: Collect
        },
        // 我的消息
        {
          path: '/message',
          component: Message
        },
        // 关于优铺
        {
            path: '/aboutUP',
            component: AboutUP
        },
        // 搜索页
        {
            path: '/search',
            component: Search
        },
        // 登录页
        {
            path: '/login',
            component: Login
        },
        // 资讯详情
        {
            path: '/consult',
            component: Consult
        },
        // 委托找铺
        {
            path: '/seekShop',
            component: SeekShop
        },
        // 委托转铺
        {
            path: '/turnShop',
            component: TurnShop
        },
        // 选择城市
        {
            path: '/citySelection',
            component: CitySelection
        },
        // 选择城市商铺
        {
            path: '/citySelection1',
            component: CitySelection1
        },
        // 邀请好友
        {
            path: '/inviteFriends',
            component: InviteFriends
        },
        // 我的邀请
        {
            path: '/myInvite',
            component: MyInvite
        },
        // 邀请注册
        {
            path: '/inviteRegister',
            component: InviteRegister
        },
        // 我要纠错
        {
            path: '/errorCorrection',
            component: ErrorCorrection
        },
        // 我的发布
        {
            path: '/myPublish',
            component: MyPublish
        },
        // 转铺会员
        {
            path: '/turnShopMember',
            component: TurnShopMember
        },
        // 拍店赚钱
        {
            path: '/makeMoney',
            component: MakeMoney
        },
        // 拍店示例
        {
            path: '/sample',
            component: Sample
        },
        // 奖励规则及攻略
        {
            path: '/rule',
            component: Rule
        },
        // 拍店记录
        {
            path: '/record',
            component: Record
        },
        // 成交案例
        {
            path: '/volume',
            component: Volume
        },
        // 设置
        {
            path: '/set',
            component: SetPage
        },
        // 查看次数
        {
            path: '/lookCount',
            component: LookCount
        },
        // 看铺次数明细
        {
            path: '/lookCountDetails',
            component: LookCountDetails
        },
        //加盟租铺宝
        {
            path: '/aboutJoin',
            component: aboutJoin
        },
        //注册协议
        {
            path: "/registerAgree",
            component: registerAgree
        },
        //隐私协议
        {
            path: '/privacyAgree',
            component: privacyAgree
        },

        // 找铺详情
        {
            path: '/zhaopudetail',
            component: ZhaopuDetail
        },
        // 转铺详情
        {
            path: '/zhuanpudetail',
            component: ZhuanpuDetail
        },
        // 转铺报告
        {
            path: '/shopreport',
            component: ShopReport
        },
        // 转铺报告
        {
            path: '/fklist',
            component: FkList
        },
        // 即时通讯
        // {
        //     path: '/messageuser1',
        //     component: Message1
        // },
        // {
        //     path: '/messageuser2',
        //     component: Message2
        // },

        // 资讯列表
        {
            path: '/news',
            component: News
        },
        //发布商铺
        {
            path: "/publishop",
            component: publishop
        },
        //地图
        {
            path: "/map",
            component: map
        },
        //发布需求
        {
            path: '/publishneed',
            component: publishneed
        },
        //编辑商铺
        {
            path: '/editshop',
            component: editshop
        },
        //编辑需求
        {
            path: "/editneed",
            component: editneed
        },
        //极速着铺
        {
            path: "/zhaopuserve",
            component: Zhaopuserve
        },
        //极速转铺
        {
            path: "/zhuanpuserve",
            component: Zhuanpuserve
        }



    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            if (from.meta.keepAlive) {
                from.meta.savedPosition = Number(localStorage.scrollTop);
            }
            return { x: 0, y: to.meta.savedPosition || 0 }
        }
    }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js